<template>
  <div id="orders-kanban">
    <div
      class="row"
      :style="!!isMobile && `margin-left: calc(-${status - 2}00vw - 15px)`"
    >
      <div
        v-for="(oStatus, iStatus) in orders"
        :key="iStatus"
        class="col-lg-4 col-xs-4 column"
      >
        <div class="d-show">
          <div class="status">
            <div class="d-flex align-center">
              <i
                class="fal"
                :class="{
                  'fa-hat-chef': oStatus.id === 2,
                  'fa-shopping-bag': oStatus.id === 3,
                  'fa-check': oStatus.id === 4,
                }"
              ></i>
              <p>{{ oStatus.name }}</p>
            </div>
            <span class="qty">{{ countByStatus[oStatus.id] }}</span>
          </div>
        </div>

        <div v-if="!isMobile || (isMobile && oStatus.id === tabIndex)">
          <div v-if="oStatus.orders.length > 0">
            <orders-card
              @open-order="openOrder"
              v-for="(oOrder, iOrder) in oStatus.orders"
              :key="iOrder"
              class="w-100"
              :oOrder="oOrder"
            />
          </div>
          <div
            v-else-if="oStatus.orders.length === 0 && !oStatus.id === 2"
            class="w-100"
          >
            <div id="emptyProduction">
              <p class="no-order">
                {{ StringLanguage.noOrders }}
                <span v-if="oStatus.id === 2">{{ StringLanguage.in }}</span>
                {{ oStatus.name }}
              </p>
            </div>
          </div>
          <!-- REMOVIDO TEMPORARIAMENTE PARA TESTES
          <div
            v-if="
              oStatus.id === 2 &&
              showOrderButtonSimulator &&
              total_fake_orders < 5
            "
            @click="simulateOrder"
          >
            <div class="simulate-order">
              <div class="icon">
                <i class="fal fa-utensils-alt"></i>
              </div>
              <p>SIMULAR NOVO PEDIDO</p>
              <span>
                O pedido será meramente ilustrativo, não constará em relatórios
                e não irá disparar impressão.
              </span>
            </div>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OrdersCard from '@/containers/Orders/OrdersCard';
import BaseBox from '@/components/Box';

export default {
  data() {
    return {
      open_actions: {},
      total_fake_orders: 0,
    };
  },
  props: {
    orders: Object,
    countByStatus: Object,
    status: Number,
    tabIndex: Number,
    // showOrderButtonSimulator: Boolean,
  },
  methods: {
    simulateOrder() {
      this.$emit('simulate-order');
      this.total_fake_orders += 1;
    },
    openOrder(oOrder) {
      this.$emit('open-order', oOrder);
    },
    addOrderToChangeStatus(oOrder) {
      this.$emit('add-order-to-change-status', oOrder);
    },
    removeOrderFromChangeStatus(orderId) {
      this.$emit('remove-order-from-change-status', orderId);
    },
    changeStatus(oOrder) {
      this.$emit('change-status', oOrder);
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
    }),
  },
  components: {
    OrdersCard,
    BaseBox,
  },
};
</script>
<style scoped>
.simulate-order {
  padding: 20px;
  border-radius: 5px;
  background: #442b38;
  border: 2px dashed #ff338278;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 20px;
  height: 245px;
}

.simulate-order:hover {
  background: #ff33822e;
  cursor: pointer;
}

.simulate-order .icon {
  background: #ff338254;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.simulate-order .icon i {
  color: #ffcc99;
  font-size: 22px;
}

.simulate-order p {
  color: #ffcc99;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 5px;
}

.simulate-order span {
  color: #cccccc;
  font-size: 12px;
  line-height: 20px;
}

#orders-kanban .status {
  padding: 15px 25px;
  border-radius: 5px;
  color: #c9c9c9d9;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
  background-color: var(--tabs-mobile);
}

#orders-kanban .status i {
  margin-right: 10px;
  font-size: 17px;
  color: #c9c9c9d9;
}

#orders-kanban .status .qty {
  background-color: #ff338249;
  border-radius: 14px;
  padding: 5px 10px;
}

#orders-kanban .column:first-child {
  border-right: 1px solid #333;
}

#orders-kanban .column:last-child {
  border-left: 1px solid #333;
}

#orders-kanban .no-order {
  background: var(--box);
  box-shadow: 0px 1px 15px #0000001a;
  border-radius: 5px;
  padding: 15px 20px;
  font-size: 14px;
  color: #aaaaaae6;
}

@media screen and (max-width: 991px) {
  #orders-kanban .column:first-child,
  #orders-kanban .column:last-child {
    border: none;
  }
  .tag {
    font-size: 12px;
  }
  #orders-kanban {
    overflow: hidden;
  }
  #orders-kanban > div {
    width: 300vw;
    transition: 0.3s all ease-in-out;
  }
  #orders-kanban .no-order {
    font-size: 12px;
  }
}
</style>
